import React, { FC } from "react";
import { createGlobalStyle } from "styled-components";
import { InputSwitch } from "primereact/inputswitch";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Word from "saur_ui_library/src/Atoms/Word/Word";
type SwitchProps = {
  name: string;
  className: string;
  checked: boolean | null;
  id: string;
  onChange: any;
  title: string;
};
const Switch: FC<SwitchProps> = (props) => {
  return (
    <Container className="global-switch sds-reset-style">
      <Styles />
      <Container className="switch">
        <Word
          variant="p"
          textStyle="normalReg"
          value={props.title}
          className="title"
        />
        <InputSwitch checked={props.checked as boolean} onChange={props.onChange} />
      </Container>
    </Container>
  );
};

export const Styles = createGlobalStyle`
.global-switch.sds-reset-style{
  
  .switch{
  .pi{
    font-family: 'primeicons';
    }
    flex-direction: row;
    justify-content: space-evenly;
    margin-bottom: 16px;
  .title{
    line-height: 10px;
    width: 140px;
    }
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: #BBE8CD;
  }
  .p-inputswitch .p-inputswitch-slider{
    height: 15px;
    width: 40px;
  }

  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before{
    background: #63D1B4;
  }
} 
  `;

export default Switch;
